import { Routes } from '@angular/router';

//components
import { QrCodeScannerComponent } from './qr-code-scanner/qr-code-scanner.component';
import { NumberScannerComponent } from './number-scanner/number-scanner.component';
import { ParamsConstants } from './shared/constants';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { TestingComponent } from './testing/testing.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: `home`,
        component: HomeComponent,
    },
    {
        path: `home/:${ParamsConstants.LOCATION_CODE}/:${ParamsConstants.API_KEY}`,
        component: HomeComponent,
    },
    {
        path: 'testing',
        loadChildren: () => import('./testing/testing.routes').then(m => m.TestingRoutes),
        canActivate: [AuthGuard]
    },
    {
        path: 'binding',
        loadChildren: () => import('./binding/binding.routes').then(m => m.BindingRoutes),
        canActivate: [AuthGuard]
    },
    {
        path: 'stocking',
        loadChildren: () => import('./stocking/stocking.routes').then(m => m.StockingRoutes),
        canActivate: [AuthGuard]
    }
];
